import { Link } from "react-router-dom";
import { useAuth, API } from "../App";
import { Button } from "./ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "./ui/sheet";
import { Home, Menu } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";

const Navbar = () => {
  const { user, login, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState("/logo.png");

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings/business`);
        if (response.data?.logo_url) {
          setLogoUrl(response.data.logo_url);
        }
      } catch (error) {
        // Keep default logo on error
      }
    };
    fetchSettings();
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-border/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 active:scale-95 transition-transform">
            <img src={logoUrl} alt="Buyorent" className="h-10 w-auto object-contain" />
            <span className="font-serif text-xl font-semibold tracking-tight">Buyorent</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/properties" className="text-sm font-medium hover:text-primary active:scale-95 transition-all">
              Properties
            </Link>
            <Link to="/agents" className="text-sm font-medium hover:text-primary active:scale-95 transition-all">
              Agents
            </Link>
            <Link to="/mortgage-calculator" className="text-sm font-medium hover:text-primary active:scale-95 transition-all">
              Calculator
            </Link>
            {user ? (
              <div className="flex items-center gap-4">
                <Link to="/dashboard" className="text-sm font-medium hover:text-primary active:scale-95 transition-all">
                  Dashboard
                </Link>
                <button
                  onClick={logout}
                  className="text-sm font-medium text-muted-foreground hover:text-foreground active:scale-95 transition-all"
                >
                  Logout
                </button>
              </div>
            ) : (
              <Button 
                onClick={login} 
                className="bg-primary text-primary-foreground hover:bg-primary/90 active:scale-95 h-10 px-6 rounded-sm transition-all"
              >
                Sign In
              </Button>
            )}
          </div>

          {/* Mobile Menu */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild className="md:hidden">
              <button className="p-2">
                <Menu className="w-6 h-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[280px]">
              <div className="flex flex-col gap-6 mt-8">
                <Link 
                  to="/properties" 
                  className="text-lg font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Properties
                </Link>
                <Link 
                  to="/agents" 
                  className="text-lg font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Agents
                </Link>
                <Link 
                  to="/mortgage-calculator" 
                  className="text-lg font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Calculator
                </Link>
                {user ? (
                  <>
                    <Link 
                      to="/dashboard" 
                      className="text-lg font-medium"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button 
                      onClick={() => { logout(); setMobileMenuOpen(false); }}
                      className="text-lg font-medium text-left text-muted-foreground"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <Button onClick={() => { login(); setMobileMenuOpen(false); }}>
                    Sign In
                  </Button>
                )}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
